import {gsap} from 'gsap'

export default {
  props: ['tempStep', 'componentName'],
  computed: {
    target: function () {
      return this.$refs['container']
    }
  },
  mounted() {
    gsap.set(this.target, {autoAlpha: 0, y: -50})
    gsap.to(this.target, {autoAlpha: 1, y: 0, ease: 'slow'})
  },
  watch: {
    tempStep(newValue) {
      if (newValue !== this.componentName) {
        gsap.to(this.target, {
          autoAlpha: 0, y: 50, ease: 'slow', onComplete: () => {
            this.$emit('swapComponent', newValue)
          }
        })
      }
    }
  }
}
